import { render } from "./SliderTestimoniHome.vue?vue&type=template&id=1f8eea70&scoped=true"
import script from "./SliderTestimoniHome.vue?vue&type=script&lang=js"
export * from "./SliderTestimoniHome.vue?vue&type=script&lang=js"

import "./SliderTestimoniHome.vue?vue&type=style&index=0&id=1f8eea70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8eea70"]])

export default __exports__